module.exports = __webpack_public_path__ + "static/media/100047806_333947884237841_7825940964664410112_n.dcf79834.jpg";